import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingListGroup } from './types/mailing-list-group.type';

/**
 * Fetches a specific duplicate group from a mailing list by mailing ID and group number.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing list.
 * @returns A promise resolving to the operation result containing the mailing list group data.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getMailingListDupeGroup = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingListGroup[]>>(
        formatString(Uri.mailing.getMailingListDupeGroup, mailingId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
